// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const AlignTopIcon = props => <Icon {...props} dangerouslySetIcon={'<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M1 4a1 1 0 000 2h22a1 1 0 100-2H1zm8 4a3 3 0 00-3 3v6a3 3 0 003 3h6a3 3 0 003-3v-6a3 3 0 00-3-3H9zm-1 3a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H9a1 1 0 01-1-1v-6z"/></svg>'} />;

AlignTopIcon.displayName = 'AlignTopIcon';

export default AlignTopIcon;
